import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "panel-section p-bottom-8 request-fulfillment-date" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "has-text-weight-semibold" }, "Anticipated fulfillment", -1)
const _hoisted_3 = { class: "m-left-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "help" }, " Changing this date may have legal consquences. Please refer to appropriate laws. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrIconButton = _resolveComponent("NrIconButton")!
  const _component_NrTooltip = _resolveComponent("NrTooltip")!
  const _component_NrIcon = _resolveComponent("NrIcon")!
  const _component_NrDatepicker = _resolveComponent("NrDatepicker")!
  const _component_NrModal = _resolveComponent("NrModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["panel-item is-flex is-align-items-center is-justify-content-space-between", { 'panel-item--editable': _ctx.$can('publish', 'Request') }])
    }, [
      _hoisted_2,
      (_ctx.$can('publish', 'Request'))
        ? (_openBlock(), _createBlock(_component_NrTooltip, {
            key: 0,
            label: "Edit anticipated fulfillment date"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_NrIconButton, {
                variant: "minimal-neutral",
                icon: { name: 'pencil-alt', type: 'regular' },
                "aria-label": "Edit anticipated fulfillment date",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleModal(true)))
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", null, _toDisplayString(_ctx.date), 1)
    ]),
    _createVNode(_component_NrModal, {
      title: "Change anticipated fulfillment date",
      show: _ctx.showModal,
      hasSecondaryButton: true,
      disabeButtons: _ctx.updating,
      secondaryButtonText: "Cancel",
      primaryButtonText: "Save date",
      onOnCloseClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleModal(false))),
      onOnSecondaryClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleModal(false))),
      onOnPrimaryClick: _ctx.handleSaveData
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent","stop"]))
        }, [
          _createElementVNode("fieldset", null, [
            _createVNode(_component_NrDatepicker, {
              onInput: _ctx.handleDateInput,
              placeholder: "Type or select a date (mm/dd/yyyy)",
              modelValue: _ctx.computedDate,
              "unselectable-dates": _ctx.unselectableDates
            }, {
              label: _withCtx(() => [
                _createTextVNode("New anticipated fulfillment date")
              ]),
              trigger: _withCtx(() => [
                _createVNode(_component_NrIcon, { name: "calendar-alt" })
              ]),
              _: 1
            }, 8, ["onInput", "modelValue", "unselectable-dates"]),
            _hoisted_4
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["show", "disabeButtons", "onOnPrimaryClick"])
  ]))
}